var scope_0 = require('/Users/mathiasquintero/NonProfitLovesKotlin/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/10c4ec041057f16c416e39194e70c4d0.js').default;export default
        Object.assign({}, scope_0 )
    